import React from 'react';

import CardHOC from './Components/CardHOC';
import Display from '../../../Types/Components/Display';

const DisplayType = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <Display question={question} />
  </CardHOC>
}

export default DisplayType;